/*
 Initial state and properties
 */
 export const initialState = {
    mode:"POST",
    rutaIdSelected:0,
    defaultDataRuta:null
 }
 /*
  Action types
  */
 export const SET_MODE = 'SET_MODE'
 export const SET_RUTA_ID = 'SET_RUTA_ID'
 export const SET_DEFAULT_DATA = 'SET_DEFAULT_DATA'
 /*
  Arrow function for change state
  */
 export const setMode = (payload) => ({
   type: SET_MODE,
   payload,
 });
 export const setRutaId = (payload) => ({
  type: SET_RUTA_ID,
  payload,
})
export const setDefaultData = (payload) => ({
  type: SET_DEFAULT_DATA,
  payload,
})
 /*
  Reducer to describe how the state changed
  */
 export default function Reducer(state = initialState, { type, payload }) {
   switch (type) {
     case SET_MODE:
       return {
         ...state,
         mode: payload,
       }
       case SET_RUTA_ID:
        return {
          ...state,
          rutaIdSelected: payload,
        }
        case SET_DEFAULT_DATA:
          return {
            ...state,
            defaultDataRuta: payload,
          }
     default:
       return state
   }
 }
 